import { Drawer } from "antd";
import close from "./../../../assets/images/close.svg";
import useStore from "../../../store/useStore";

const RewardsQuestionPopup = ({ selectedQuestion, closePopup }: any) => {
  const { doctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
  }));
  const commission = doctorDetails?.user?.commission || 0;
  const rewardsQuestions = [
    {
      title: "How Rewards are calculated",
      description: [
        `Your rewards are calculated as ${commission}% of the value of each care plan purchased by the patients you refer.`,
        `For example, if a patient you referred purchases a care plan worth ₹5,000, you will earn ₹${
          (commission / 100) * 5000 || 0
        } as your reward (which is ${commission}% of ₹5,000).`,
        "These rewards accumulate over time and can be a significant addition to your earnings.",
      ],
    },
    {
      title: "Withdrawal Process",
      description: [
        "To withdraw your accumulated rewards, please reach out to your Relationship Manager (RM). They will guide you through the process and ensure you receive your earnings promptly.",
      ],
    },
  ];
  return (
    <Drawer
      placement="bottom"
      onClose={closePopup}
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden"
    >
      <div className="flex flex-col gap-y-6">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            {rewardsQuestions[selectedQuestion].title}
          </div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
        {rewardsQuestions[selectedQuestion].description.map((item) => {
          return <div>{item}</div>;
        })}
      </div>
    </Drawer>
  );
};

export default RewardsQuestionPopup;
